import client from '../../shared/api/client';

/* ── Products ──────────────────────────────────────────────────── */
export const adminListProducts = () =>
  client.get('/admin/products/').then(r => r.data);

export const adminCreateProduct = data =>
  client.post('/admin/products/', data).then(r => r.data);

export const adminUpdateProduct = (id, data) =>
  client.put(`/admin/products/${id}/`, data).then(r => r.data);

export const adminDeleteProduct = id =>
  client.delete(`/admin/products/${id}/`).then(r => r.data);

/* ── Images ────────────────────────────────────────────────────── */
export const adminUploadImage = (productId, file) => {
  const form = new FormData();
  form.append('file', file);
  return client.post(`/admin/products/${productId}/images/`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then(r => r.data);
};

export const adminDeleteImage = id =>
  client.delete(`/admin/images/${id}/`);

export const adminSetPrimaryImage = id =>
  client.patch(`/admin/images/${id}/`, { is_primary: true }).then(r => r.data);

export const adminGetProduct = id =>
  client.get(`/admin/products/${id}/`).then(r => r.data);

export const adminReorderImages = (productId, imageIds) =>
  client.post(`/admin/products/${productId}/images/reorder/`, { image_ids: imageIds }).then(r => r.data);

export const adminGetProductPostImage = (productId) =>
  client.get(`/admin/products/${productId}/post-image.jpg`, { responseType: 'blob' })
    .then(r => r.data);

/* ── Orders ────────────────────────────────────────────────────── */
export const adminListOrders = (state) =>
  client.get('/admin/orders/', { params: state ? { state } : {} }).then(r => r.data);

export const adminUpdateOrderState = (id, state) =>
  client.patch(`/admin/orders/${id}/`, { state }).then(r => r.data);

// Edición total de la orden (estado, pago, dirección, propietario, montos, líneas).
export const adminUpdateOrder = (id, data) =>
  client.put(`/admin/orders/${id}/`, data).then(r => r.data);

export const adminGetOrder = id =>
  client.get(`/admin/orders/${id}/`).then(r => r.data);

/* ── Clientes (partners) ───────────────────────────────────────── */
export const adminListPartners = params =>
  client.get('/admin/partners/', { params }).then(r => r.data);

export const adminGetPartner = id =>
  client.get(`/admin/partners/${id}/`).then(r => r.data);

export const adminUpdatePartner = (id, data) =>
  client.put(`/admin/partners/${id}/`, data).then(r => r.data);

export const adminDeletePartner = id =>
  client.delete(`/admin/partners/${id}/`).then(r => r.data);

export const adminRestorePartner = id =>
  client.post(`/admin/partners/${id}/restore/`).then(r => r.data);

export const adminMergePartner = (id, targetId) =>
  client.post(`/admin/partners/${id}/merge/`, { target_id: targetId }).then(r => r.data);

/* ── Novedades del seguimiento ─────────────────────────────────── */
export const adminListOrderNotes = id =>
  client.get(`/admin/orders/${id}/notes/`).then(r => r.data);

export const adminAddOrderNote = (id, note) =>
  client.post(`/admin/orders/${id}/notes/`, { note }).then(r => r.data);

export const adminDeleteOrderNote = (id, noteId) =>
  client.delete(`/admin/orders/${id}/notes/${noteId}/`);

/* ── Bot: números ignorados ───────────────────────────────────── */
export const adminListIgnoredPhones = () =>
  client.get('/admin/bot/ignored/').then(r => r.data);

export const adminAddIgnoredPhone = data =>
  client.post('/admin/bot/ignored/', data).then(r => r.data);

export const adminRemoveIgnoredPhone = id =>
  client.delete(`/admin/bot/ignored/${id}/`);

/* ── AI Assistant ──────────────────────────────────────────────── */
export const adminAiInfo = () =>
  client.get('/admin/ai/info').then(r => r.data);

export const adminAiReply = ({ messages }) =>
  client.post('/admin/ai/reply', { messages }).then(r => r.data);
